import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import PageHeader from "../../components/PageHeader/PageHeader";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const DeliveryPartnerOrderView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    id,
    partnerId,
    tab,
    page,
    data: routeData,
    viewData,
  } = location.state ?? {};

  const [form, setForm] = useState([
    {
      id: 1,
      name: "Pickup Proof",
      key: "pickup_proof_url",
      value: "",
      type: "img",
    },
    {
      id: 2,
      name: "Delivery Proof",
      key: "delivery_proof_url",
      value: "",
      type: "img",
    },
    {
      id: 3,
      name: "Food Amount",
      key: "food_amount",
      value: "",
      type: "input",
    },
    {
      id: 4,
      name: "Tax Amount",
      key: "tax_amount",
      value: "",
      type: "input",
    },
    {
      id: 5,
      name: "Total Delivery Amount",
      key: "total_delivery_amount",
      value: "",
      type: "input",
    },
    {
      id: 6,
      name: "Delivery Partner Amount",
      key: "delivery_partner_amount",
      value: "",
      type: "input",
    },
    {
      id: 7,
      name: "Delivery Partner Admin Amount",
      key: "delivery_partner_admin_amount",
      value: "",
      type: "input",
    },
  ]);

  const mapOrderData = (data) => {
    if (!data) return;

    setForm((prev) =>
      prev.map((item) => {
        const fieldValue = data?.[item.key];

        if (item.type === "img") {
          return {
            ...item,
            value: fieldValue || "",
          };
        }

        return {
          ...item,
          value:
            fieldValue !== null && fieldValue !== undefined
              ? String(fieldValue)
              : "",
        };
      }),
    );
  };

  const fetchData = async (orderId) => {
    if (!orderId || !partnerId) return;

    try {
      const url = `${URLS.DELIVERYPARTNER}${partnerId}/orders/${orderId}/`;

      const res = await get(url);

      if (res?.status === "success") {
        mapOrderData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching delivery partner order:", error);
    }
  };

  useEffect(() => {
    // If route already contains order data, show it immediately
    if (routeData) {
      mapOrderData(routeData);
    }

    // Fetch latest data from API
    if (id) {
      fetchData(id);
    }
  }, [id, partnerId]);

  const handleBack = () => {
    navigate("/delivery-partner-view", {
      state: {
        page: page || 1,
        tab: tab || 1,
        id: partnerId,
        viewData: viewData,
      },
    });
  };

  return (
    <div>
      <PageHeader
        title="Delivery Partner Order"
        showBackButton={true}
        onBackClick={handleBack}
      />

      <div className="form-grid">
        {form.map((item) => {
          // Input fields
          if (item.type === "input") {
            return (
              <div className="form-item" key={item.id}>
                <div className="form-group">
                  <label>{item.name}</label>

                  <input type="text" value={item.value} readOnly />
                </div>
              </div>
            );
          }

          // Image fields
          if (item.type === "img") {
            return (
              <div className="form-item" key={item.id}>
                <div className="form-group">
                  <label>{item.name}</label>

                  <div className="img-row">
                    {item.value ? (
                      <img
                        src={item.value}
                        className="food-img"
                        alt={item.name}
                        style={{
                          width: 180,
                          height: 180,
                          objectFit: "cover",
                          cursor: "pointer",
                          borderRadius: 8,
                        }}
                        onClick={() => window.open(item.value, "_blank")}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                </div>
              </div>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default DeliveryPartnerOrderView;
